// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicationActionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ApproveApplicationRequest,
  ConditionallyApproveApplicationRequest,
  DeclineApplicationRequest,
} from '../..';

export const CappsLandlordApplicationActionsWebApiHandler_approveApplication_Path =
  '/api/web/landlord/v1/applications/approveApplication';

export const CappsLandlordApplicationActionsWebApiHandler_approveApplication = (
  postData: ApproveApplicationRequest,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ApproveApplicationRequest, void>(
    {
      endpoint: CappsLandlordApplicationActionsWebApiHandler_approveApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication_Path =
  '/api/web/landlord/v1/applications/conditionallyApproveApplication';

export const CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication = (
  postData: ConditionallyApproveApplicationRequest,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ConditionallyApproveApplicationRequest, void>(
    {
      endpoint: CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsLandlordApplicationActionsWebApiHandler_declineApplication_Path =
  '/api/web/landlord/v1/applications/declineApplication';

export const CappsLandlordApplicationActionsWebApiHandler_declineApplication = (
  postData: DeclineApplicationRequest,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeclineApplicationRequest, void>(
    {
      endpoint: CappsLandlordApplicationActionsWebApiHandler_declineApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
